import { useMutation } from 'react-query';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import {
  COUNTRY_CODES,
  SPECIFIC_ERROR_CODES,
} from '@savgroup-front-common/constants';
import { toast } from '@savgroup-front-common/core/atoms/Toast';
import { selectLocale } from '@savgroup-front-common/core/domains/i18n/selectors';

import { SellerService } from '@/api';

import { PickedCompany } from '../../../OnboardingActivities/OnboardingActivities.types';

import messages from './messages';
import { OnboardingFormFieldValues } from './useOnboardingFormContext';

interface UpsertSalesLeadArgs extends OnboardingFormFieldValues {
  pickedCompany?: PickedCompany;
}

const useUpsertSalesLeadCommand = () => {
  const navigate = useNavigate();
  const locale = useSelector(selectLocale);

  const { mutateAsync: handleSubmitSalesLead, isLoading } = useMutation(
    [],
    async (data: UpsertSalesLeadArgs) => {
      const response = await SellerService.upsertSalesLeadCommand({
        companyName: data.companyName,
        email: data.email,
        firstName: data.firstName,
        cName: data.cName,
        lastName: data.lastName,
        phone: data.phone,
        language: locale,
        address: {
          address: data.address,
          postalCode: data.postalCode,
          city: data.city,
          countryCode: data.countryCode.value as COUNTRY_CODES,
        },
      });

      if (
        response.errors?.at(0)?.code ===
        SPECIFIC_ERROR_CODES.INVALID_EMAIL_ADDRESS
      ) {
        toast.error(messages.invalidEmail);

        return undefined;
      }

      if (response.failure) {
        toast.error(messages.accoundCreationError);

        return undefined;
      }

      navigate(`/onboarding/${response.value}`, {
        state: {
          pickedCompany: data.pickedCompany,
          companyName: data.companyName,
        },
      });

      return undefined;
    },
  );

  return { handleSubmitSalesLead, isLoading };
};

export default useUpsertSalesLeadCommand;
